import * as yup from "yup";
import React, { FC } from "react";
import { Block } from "baseui/block";
import { expandPadding } from "kanopi-components/utils/styles";
import { Form } from "kanopi-components/Form";
import { FormControl, Input, InputWrapper } from "kanopi-components/Input";
import { HeadingMedium, ParagraphSmall } from "baseui/typography";
import { ResponsiveNextButton } from "../ResponsiveNextButton/ResponsiveNextButton";
import { useForm } from "react-weaver";
import { useRegister } from "kw/auth/hooks/useRegister";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { useUser } from "kw/auth/useUser";
import { WidthContainer } from "kw/util/ChatFlow";

type TPasswordLessUserRegisterForm = {
  onRegistrationComplete?: (...args: unknown[]) => void;
  submitButtonText?: string;
};
export const PasswordLessUserRegisterForm: FC<TPasswordLessUserRegisterForm> = ({
  onRegistrationComplete,
  submitButtonText = "Register",
}) => {
  const [, theme] = useStyletron();
  const validator = yup.object().shape({
    email: yup.string().required().label("Email"),
    confirmEmail: yup
      .string()
      .required()
      .label("Confirm email")
      .oneOf([yup.ref("email"), null], "Both emails need to match"),
  });
  const { register, loading } = useRegister();
  const user = useUser();
  const { fieldProps, errors, notReady } = useForm({
    initialValues: { email: user?.contactEmail || "", confirmEmail: "" },
    validator,
  });

  const onRegister = async () => {
    if (user?.isLazy) {
      register(
        {
          email: fieldProps.email.value,
        },
        true,
        () => {
          onRegistrationComplete?.();
        }
      );
    } else {
      onRegistrationComplete?.();
    }
  };
  return (
    <Form>
      <WidthContainer>
        <Block
          backgroundColor={theme.colors.backgroundSecondary}
          {...expandPadding([
            theme.sizing.scale900,
            theme.sizing.scale800,
            theme.sizing.scale900,
            theme.sizing.scale800,
          ])}
          overrides={{
            Block: {
              style: {
                boxSizing: "border-box",
              },
            },
          }}
        >
          <HeadingMedium margin={0}>Communication email</HeadingMedium>
          <ParagraphSmall marginBottom={0}>
            Please enter the email address where you would like to receive documents and
            communication related to your policy.
          </ParagraphSmall>
          <InputWrapper>
            <FormControl label="Email" error={errors?.email}>
              <Input {...fieldProps.email} required />
            </FormControl>
          </InputWrapper>
          <InputWrapper>
            <FormControl label="Confirm email" error={errors?.confirmEmail}>
              <Input {...fieldProps.confirmEmail} required />
            </FormControl>
          </InputWrapper>
        </Block>
        <ResponsiveNextButton
          fixed={true}
          narrow={false}
          onClick={onRegister}
          disabled={loading || notReady}
          isLoading={loading}
          text={submitButtonText}
        />
      </WidthContainer>
    </Form>
  );
};
